export default __webpack_public_path__ + "static/media/AnuncieMobile.55a55b85.png";